<template>
    <div class="profile__table__box table-responsive">
        <table
            id="vehicles__table"
            class="profile__table table"
            cellpadding="0"
            cellmargin="0"
            width="100%"
        >
            <thead>
                <tr>
                    <th>Placa</th>
                    <th>Día</th>
                    <th>Hora</th>
                    <th>Taller</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="element in list" :key="element.id">
                    <td class="text-center">{{ element.vehicle.plate }}</td>
                    <td class="text-center">{{ element.schedule_date }}</td>
                    <td class="text-center">{{ element.schedule_time }}</td>
                    <td class="text-center">{{ element.garage_name }}</td>
                    <td class="text-right">
                        <a
                            href="#"
                            v-if="element.limit_date > 1"
                            class="edit"
                            @click.prevent="getUrlEdit(element.id)"
                            data-tooltip="tooltip"
                            data-bs-placement="top"
                            title="Reprogramar"
                        >
                            <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="465.2px"
                                height="461.83px"
                                viewBox="0 0 465.2 461.83"
                                style="enable-background: new 0 0 465.2 461.83"
                                xml:space="preserve"
                            >
                                <g id="Layer_2_1_">
                                    <path
                                        d="M279.59,422.03c-3.84,0.96-7.75,1.8-11.63,2.52c-10.15,1.89-16.86,11.65-14.98,21.8c0.93,5,3.77,9.16,7.62,11.88 c3.97,2.8,9.02,4.06,14.17,3.1c4.62-0.86,9.28-1.87,13.85-3.01c10.02-2.49,16.13-12.65,13.63-22.66 C299.76,425.63,289.62,419.53,279.59,422.03z"
                                    />
                                    <path
                                        d="M417.89,171.36c1.31,3.95,3.81,7.17,6.97,9.4c4.68,3.3,10.81,4.41,16.66,2.48c9.81-3.26,15.12-13.83,11.88-23.63 c-1.48-4.47-3.12-8.95-4.86-13.31c-3.84-9.59-14.71-14.26-24.31-10.42c-9.58,3.83-14.26,14.71-10.42,24.31 C415.27,163.84,416.65,167.61,417.89,171.36z"
                                    />
                                    <path
                                        d="M340.36,395.33c-3.3,2.18-6.7,4.29-10.13,6.26c-8.95,5.16-12.01,16.6-6.85,25.55c1.4,2.43,3.27,4.42,5.42,5.94 c5.77,4.06,13.6,4.67,20.13,0.91c4.08-2.35,8.13-4.85,12.06-7.45c8.61-5.69,10.98-17.29,5.29-25.91 C360.57,392,348.98,389.63,340.36,395.33z"
                                    />
                                    <path
                                        d="M465.02,223.59c-0.41-10.32-9.1-18.36-19.43-17.95c-10.31,0.41-18.35,9.1-17.95,19.42c0.15,3.95,0.2,7.95,0.1,11.89 c-0.14,6.47,3.02,12.24,7.94,15.71c2.93,2.06,6.49,3.31,10.35,3.4c10.32,0.23,18.88-7.96,19.11-18.29 C465.25,233.07,465.21,228.3,465.02,223.59z"
                                    />
                                    <path
                                        d="M414.83,346.13c-8.28-6.21-19.99-4.52-26.19,3.74c-2.37,3.16-4.87,6.29-7.43,9.3c-6.69,7.86-5.74,19.67,2.11,26.36 c0.45,0.38,0.9,0.73,1.37,1.06c7.81,5.51,18.67,4.24,24.99-3.17c3.06-3.59,6.04-7.32,8.87-11.1 C424.77,364.05,423.09,352.33,414.83,346.13z"
                                    />
                                    <path
                                        d="M442.32,278.53c-9.86-3.09-20.35,2.4-23.44,12.25c-1.18,3.77-2.49,7.55-3.91,11.25c-3.11,8.16-0.13,17.13,6.69,21.94 c1.25,0.88,2.63,1.62,4.13,2.19c9.65,3.68,20.45-1.16,24.13-10.81c1.68-4.4,3.24-8.91,4.65-13.38 C457.66,292.11,452.18,281.62,442.32,278.53z"
                                    />
                                    <path
                                        d="M198,424.71c-16.72-3-32.76-8.11-47.97-15.24c-0.18-0.09-0.34-0.2-0.53-0.29c-3.58-1.69-7.16-3.49-10.63-5.38 c-0.01-0.01-0.03-0.02-0.05-0.03c-6.36-3.5-12.57-7.38-18.61-11.63C32.24,330.17,11.09,208.18,73.06,120.21 c13.48-19.12,29.78-35.07,47.96-47.72c0.22-0.16,0.45-0.31,0.67-0.47c64.07-44.14,151.06-47.12,219.09-1.76l-14.61,21.11 c-4.06,5.88-1.56,10.16,5.55,9.52l63.47-5.68c7.12-0.64,11.38-6.8,9.46-13.68l-17.04-61.41c-1.91-6.88-6.79-7.71-10.86-1.83 l-14.64,21.16C312.18,5.95,252.3-6.83,192.87,3.48c-5.99,1.04-11.89,2.3-17.71,3.78c-0.04,0.01-0.08,0.01-0.12,0.02 c-0.23,0.06-0.45,0.13-0.67,0.19C123.12,20.63,78.41,50.52,46.5,93.17c-0.27,0.32-0.55,0.63-0.8,0.98 c-1.06,1.43-2.11,2.89-3.15,4.35c-1.69,2.4-3.35,4.85-4.94,7.31c-0.2,0.3-0.35,0.6-0.53,0.9C10.76,147.5-1.94,194.67,0.24,242.7 c0,0.16,0,0.32,0,0.48c0.21,4.69,0.58,9.45,1.09,14.13c0.03,0.3,0.09,0.59,0.14,0.89c0.52,4.71,1.18,9.43,2,14.14 c8.34,48.14,31.05,91.46,65.08,125.16c0.08,0.08,0.16,0.17,0.24,0.25c0.03,0.03,0.06,0.05,0.09,0.08 c9.14,9.02,19.09,17.36,29.79,24.9c28.02,19.74,59.22,32.8,92.73,38.81c10.17,1.83,19.88-4.94,21.7-15.1 C214.92,436.26,208.16,426.54,198,424.71z"
                                    />
                                    <path
                                        d="M221.12,81.51c-8.36,0-15.14,6.78-15.14,15.13v150.75l137.87,71.27c2.22,1.15,4.6,1.69,6.93,1.69 c5.48,0,10.77-2.98,13.45-8.18c3.83-7.43,0.93-16.55-6.49-20.38l-121.51-62.82V96.64C236.24,88.29,229.48,81.51,221.12,81.51z"
                                    />
                                </g>
                            </svg>
                        </a>
                        <a
                            href="#"
                            class="delete"
                            @click.prevent="deleteElement(element.id)"
                            data-tooltip="tooltip"
                            data-bs-placement="top"
                            title="Eliminar"
                        >
                            <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="450px"
                                height="512px"
                                viewBox="0 0 450 512"
                                style="enable-background: new 0 0 450 512"
                                xml:space="preserve"
                            >
                                <g>
                                    <g>
                                        <g>
                                            <path
                                                d="M405,60h-89.18l-9.75-29.24C299.93,12.36,282.77,0,263.38,0h-76.76c-19.4,0-36.55,12.36-42.7,30.76L134.18,60H45 C20.19,60,0,80.19,0,105v30c0,16.71,15.04,15,31.18,15c138.55,0,264.17,0,403.82,0c8.29,0,15-6.71,15-15v-30 C450,80.19,429.81,60,405,60z M165.81,60l6.57-19.75c2.05-6.14,7.78-10.25,14.24-10.25h76.76c6.46,0,12.19,4.12,14.22,10.25 L284.18,60H165.81z"
                                            />
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path
                                                d="M33.67,182l23.92,289.07C59.71,494.41,78.97,512,102.39,512h245.21c23.42,0,42.69-17.59,44.82-41.06L416.34,182H33.67z M150,437c0,19.77-30,19.85-30,0V227c0-19.77,30-19.85,30,0V437z M240,437c0,19.77-30,19.85-30,0V227c0-19.77,30-19.85,30,0V437z M330,437c0,19.77-30,19.85-30,0V227c0-8.29,6.71-15,15-15c8.29,0,15,6.71,15,15V437z"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from "axios";
import { ref } from "vue";
import { customAlert } from "../../../general/js/utils/swalMessages";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
    props: {
        url_list: {
            type: String,
            default: "",
        },
        url_delete: {
            type: String,
            default: "",
        },
        url_edit: {
            type: String,
            default: "",
        },
    },
    setup(props) {
        const list = ref([]);
        const getList = async () => {
            try {
                const { data } = await axios.request({
                    url: props.url_list,
                    method: "POST",
                });

                list.value = data;
            } catch (error) {
                console.error(error);
            }
        };
        getList();

        const getUrlEdit = async (id) => {
            try {
                const { data } = await axios.request({
                    url: props.url_edit,
                    method: "POST",
                    data: {
                        id: id,
                    },
                });

                window.location.href = data;
            } catch (error) {
                console.error(error);
            }
        };

        const deleteElement = async (id) => {
            Swal.fire({
                icon: "warning",
                title: "¡Ups!",
                text: "¿Está seguro que desea eliminar este registro?",
                showCancelButton: true,
                confirmButtonText: "¡Sí, eliminar!",
                cancelButtonText: "¡No, cancelar!",
            }).then((result) => {
                if (result.value) {
                    try {
                        axios
                            .request({
                                url: props.url_delete,
                                method: "POST",
                                data: { id: id },
                            })
                            .then((result) => {
                                const { data } = result;

                                if (data.type == 1) {
                                    getList();
                                }

                                customAlert(data);
                            });
                    } catch (error) {
                        console.error(error);
                    }
                }
            });
        };

        return {
            list,
            getList,
            getUrlEdit,
            deleteElement,
        };
    },
};
</script>
